// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"04a9bf12","94":"4e6d5437","305":"6692d142","318":"abac66fe","472":"445bf856","541":"eab122c8","549":"06919d0d","559":"f0fe26fb","629":"f2ef091e","632":"011b4a52","752":"4a454e77","798":"89c7870b","895":"858c5d6a","937":"de3bf0d9","953":"ffda7c4b","984":"30a12295"}[chunkId] + ".chunk.js";
};